import { css } from 'lit';
export default css `
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .header__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
  }

  amityeko-avatar {
    width: 40px;
    height: 40px;
  }

  amityeko-tg-body-one::part(base) {
    padding-left: 12px;
    color: var(--amityeko-color-gray-1);
    font-weight: 600;
  }

  .content {
    margin: 6px 0;
    background-color: var(--amityeko-color-font-light);
    opacity: var(--private-opacity);
    transition: opacity 1s ease-in-out;
  }
`;
//# sourceMappingURL=styles.js.map